import api from "$services/api";

export const initiativesApi = {
    list: (signal) => api.get("/api/initiatives", null, signal ? { signal } : undefined),
    get: (id, signal) => api.get(`/api/initiatives/${id}`, null, { signal }),
    create: (data) => api.post("/api/initiatives", data),
    update: (id, data) => api.put(`/api/initiatives/${id}`, data),
    delete: (id) => api.delete(`/api/initiatives/${id}`),
    updateStatus: (id, status) => api.post(`/api/initiatives/${id}/status`, { status }),

    getShortlist: (id, signal) => api.get(`/api/initiatives/${id}/shortlist`, null, signal ? { signal } : undefined),
    shortlist: (id, projectKey, snapshotJson) =>
        api.post(`/api/initiatives/${id}/opportunities/${projectKey}/shortlist`, { snapshotJson }),
    dismiss: (id, projectKey, dismissReasonId) =>
        api.post(`/api/initiatives/${id}/opportunities/${projectKey}/dismiss`, { dismissReasonId }),
    revert: (id, projectKey) =>
        api.post(`/api/initiatives/${id}/opportunities/${projectKey}/revert`, {}),
    recordDecision: (id, projectKey, decisionStatus, note) =>
        api.put(`/api/initiatives/${id}/opportunities/${projectKey}/decision`, { decisionStatus, note }),

    getCollaborators: (id, signal) => api.get(`/api/initiatives/${id}/collaborators`, null, { signal }),
    addCollaborator: (id, userId) => api.post(`/api/initiatives/${id}/collaborators`, { userId }),
    removeCollaborator: (id, userId) => api.delete(`/api/initiatives/${id}/collaborators/${userId}`),
    getMyCollaborators: (signal) => api.get("/api/initiatives/my-collaborators", null, { signal }),

    getActivity: (id, signal) => api.get(`/api/initiatives/${id}/activity`, null, { signal }),
    addComment: (id, text, userTags) => api.post(`/api/initiatives/${id}/activity`, { text, userTags }),

    getFollowUps: (id, signal) => api.get(`/api/initiatives/${id}/followups`, null, { signal }),
    addFollowUp: (id, data) => api.post(`/api/initiatives/${id}/followups`, data),
    updateFollowUp: (id, followUpId, updates) =>
        api.put(`/api/initiatives/${id}/followups/${followUpId}`, updates),

    getDashboard: () => api.get("/api/initiatives/dashboard"),
    getDismissOptions: (signal) => api.get("/api/settings/feedbackoptions/initiative_dismiss", null, { signal }),

    getPartnerCandidates: (id, signal) => api.get(`/api/initiatives/${id}/partner-candidates`, null, { signal }),
    sendPartnerToken: (id, crmId, partnerName, partnerEmail) =>
        api.post(`/api/initiatives/${id}/partner-tokens`, { crmId, partnerName, partnerEmail }),
};
